import React from "react";
import "../assets/styles/Contact.css";

const Contact = () => {
  return <div className="contact">Wir arbeiten darüber.</div>;
};

export default Contact;
